import React from "react";
import { graphql } from "gatsby";
import Seo from "gatsby-plugin-wpgraphql-seo";

import { Banner, Layout } from "../components";
import BookAnAppointmentBar from "../components/BookAnAppointmentBar.js";
import BlogPosts from "../components/Services/ThreeBlogs/BlogPosts.js";

const Thandav = ({
  pageContext,
  data: {
    wpPage,
    wpPage: {
      pageMeta,
      content,
      servicesMeta: { contents },
      thandavMeta,
    },
  },
}) => {
  console.log("DEBUG__thandev", { ...thandavMeta, ...pageMeta });

  return (
    <>
      <Seo post={wpPage} />
      <Layout
        footerProps={{
          showBookAppointment: false,
        }}
      >
        <Banner banner={pageMeta.pageBanner} />
        {thandavMeta.understandingThandav && (
          <section className="overflow-hidden bg-white py-12 pb-10 pt-12 lg:pt-20">
            <div className="container mx-auto">
              <div className="flex flex-wrap px-4 lg:px-0">
                <h2
                  className={`mb-6 w-full basis-full px-4 text-center font-openSans text-4xl text-secondary`}
                >
                  {thandavMeta?.understandingThandav?.title}
                </h2>
                {thandavMeta?.understandingThandav?.content ? (
                  <div className="mb-6 w-full">
                    <div
                      className="mx-auto w-full font-openSans text-lg text-black lg:w-6/12 2xl:text-xl"
                      dangerouslySetInnerHTML={{
                        __html: thandavMeta?.understandingThandav?.content,
                      }}
                    ></div>
                  </div>
                ) : null}

                {thandavMeta?.understandingThandav?.button ? (
                  <a
                    href={thandavMeta?.understandingThandav?.button?.url}
                    target={
                      thandavMeta?.understandingThandav?.button?.target ||
                      "_self"
                    }
                    className="mx-auto mb-6 inline-block rounded-xl bg-secondary px-12 py-2 text-white transition-all duration-500 hover:bg-primary"
                  >
                    {thandavMeta?.understandingThandav?.button?.title}
                  </a>
                ) : null}
              </div>
            </div>
          </section>
        )}

        {thandavMeta.details && (
          <section className="overflow-hidden bg-white py-6">
            <div className="container mx-auto">
              <div className="flex flex-wrap px-4 lg:px-0">
                <h2
                  className={`mb-10 w-full basis-full px-4 text-center font-openSans `}
                >
                  <span
                    className="bg-gray-100 px-10 py-3 text-2xl text-secondary"
                    style={{ lineHeight: "2.1" }}
                  >
                    {thandavMeta?.details?.title}
                  </span>
                </h2>
                <div className="mb-6 flex w-full flex-wrap gap-8 lg:flex-nowrap">
                  {thandavMeta?.details?.contents?.map((c, i) => (
                    <div
                      key={i}
                      className="mb-2 w-full font-openSans text-lg text-black lg:w-6/12 2xl:text-xl"
                      dangerouslySetInnerHTML={{
                        __html: c?.content,
                      }}
                    ></div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        )}

        <BookAnAppointmentBar {...thandavMeta?.bookAppointmentBar} />

        <BlogPosts posts={thandavMeta?.blogPosts} />
      </Layout>
    </>
  );
};

export default Thandav;

export const query = graphql`
  query PageQuery($id: Int) {
    wpPage(databaseId: { eq: $id }) {
      content
      pageMeta {
        pageBanner {
          desktopImage {
            localFile {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
              }
            }
          }
          mobileImage {
            localFile {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
              }
            }
          }
          bannerLink {
            target
            title
            url
          }
          captionTitle
          captionContent
          buttonLink
          buttonLabel
          showWhiteLogo
          whiteColor
          position
        }
      }
      seo {
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        canonical
        cornerstone
        schema {
          articleType
          pageType
          raw
        }
      }
      servicesMeta {
        contents {
          ... on WpPage_Servicesmeta_Contents_ImageContent {
            content
            fieldGroupName
            title
            imagePosition
            buttons {
              blueButton
              buttonData {
                target
                title
                url
              }
            }
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                }
              }
            }
          }
        }
      }
      thandavMeta {
        understandingThandav {
          title
          content
          button {
            url
            target
            title
          }
        }
        details {
          title
          titleAddBackgroundStrip
          contents {
            content
          }
        }
        bookAppointmentBar {
          title
          subTitle
          description
          buttonText
        }
        blogPosts {
          title
          blogs {
            ... on WpPost {
              id
              title
              excerpt
              slug
              date
              uri
              author {
                node {
                  name
                }
              }
              featuredImage {
                node {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                    }
                  }
                }
              }
            }
          }
          button {
            url
            title
          }
        }
      }
    }
  }
`;
